<template>
	<div class="content-editor">
		<div class="pa-block">
			<h3 class="selector-title">Contenu de l'annonce</h3>
			<div class="pa-block__inner pa-block__inner--flex">
				<div class="pa-block__main">
					<div
						class="pa-block__row pa-block__row--block pa-block__row--block--medium selector"
						:class="{
							missing: !classified.title && (titleFocused || showWarnings),
						}"
					>
						<label for="title">
							<strong>Titre de l'annonce *</strong>
						</label>
						<div class="form-container">
							<input
								type="text"
								ref="title"
								:value="classified.title"
								:maxlength="isAdmin ? 9999 : maxTitle"
								name="title"
								id="title"
								@input="updateTitle"
								@blur="titleFocused = true"
							/>
							<span class="remaining" :class="{ red: remainingTitle < 0 }">
								{{ classified.title.length }} / {{ maxTitle }}
							</span>
						</div>
						<div class="required" :if="!classified.title">
							Champ non renseigné
						</div>
						<!-- .form-container -->
					</div>
					<!-- .pa-block__row pa-block__row--block -->
					<div class="pa-block__row pa-block__row--block">
						<label for="content">
							<strong>Texte de l'annonce *</strong>
						</label>
						<div class="form-container form-container--block">
							<editor-content :editor="editor" v-if="!isIE" />
							<textarea
								v-if="isIE"
								v-model="classified.content"
								@change="updateContent"
								cols="60"
								rows="4"
								style="flex: none"
							></textarea>
							<span class="remaining" :class="{ red: remainingContent < 0 }">
								{{ contentLength }} / {{ maxContent }}
							</span>
						</div>
						<div class="required" v-show="!contentLength">
							Champ non renseigné
						</div>
						<div class="maxLength" v-show="remainingContent < 0">
							Contenu trop long
						</div>
						<!-- .form-container -->
					</div>
					<!-- .pa-block__row pa-block__row--block -->
					<div class="pa-block__row pa-block__row--block">
						<profession-selector :showWarnings="showWarnings" />
					</div>
					<div class="pa-block__row pa-block__row--block" v-if="isAdmin">
						<region-selector :showWarnings="showWarnings" />
					</div>
					<!-- .pa-block__row pa-block__row--block -->
					<div class="pa-block__row pa-block__row--block multiselect">
						<label for="content"><strong>Ville(s) *</strong></label>
						<div class="form-container">
							<multiselect
								v-model="cities"
								:options="cities_options"
								:searchable="true"
								:loading="isLoadingCities"
								@search-change="handleSearchCities"
								label="name"
								track-by="insee"
								:show-no-options="false"
								:multiple="true"
								:close-on-select="false"
								:clear-on-select="false"
								:preserve-search="true"
								placeholder="Choisir les villes"
							>
								<span slot="noResult">
									Aucun resultat pour cette recherche
								</span>
								<span slot="noOptions"> Aucune options </span>
							</multiselect>
						</div>
						<div class="help">
							Saisissez une ou plusieurs villes (limité à 10). Ne sélectionnez
							qu'un arrondissement, votre annonce concernera toute la ville.
							Votre annonce sera automatiquement classée par région et
							département pour mieux vous retrouver.
						</div>
					</div>
					<!-- .pa-block__row pa-block__row--block -->
					<div
						class="pa-block__row pa-block__row--block"
						v-if="
							getCurrentCategory.slug === 'demande-d-emploi' ||
							getCurrentCategory.slug === 'offre-d-emploi'
						"
					>
						<label for="contract-id"><strong>Type de contrat</strong></label>
						<div class="pa-checkbox__row">
							<div class="pa-checkbox__item">
								<label
									:for="`contract-${contract.id}`"
									v-bind:key="contract.id"
									v-for="contract in settings.contracts.slice(
										0,
										Math.ceil(settings.contracts.length / 2)
									)"
								>
									<input
										type="checkbox"
										:id="`contract-${contract.id}`"
										:value="contract.id"
										v-model="classified.contracts"
									/>
									&nbsp;{{ contract.name }}
								</label>
							</div>
							<div class="pa-checkbox__item">
								<label
									:for="`contract-${contract.id}`"
									v-bind:key="contract.id"
									v-for="contract in settings.contracts.slice(
										Math.ceil(settings.contracts.length / 2)
									)"
								>
									<input
										type="checkbox"
										:id="`contract-${contract.id}`"
										:value="contract.id"
										v-model="classified.contracts"
									/>
									&nbsp;{{ contract.name }}
								</label>
							</div>
						</div>
						<!-- <div class="required" :if="!classified.region">Champ non renseigné</div> -->
					</div>
					<!-- .pa-block__row pa-block__row--block -->
					<div class="pa-block__row pa-block__row--block">
						<profil-email :showWarnings="showWarnings" />
					</div>
					<!-- .pa-block__row pa-block__row--block -->
					<div
						v-if="classified.mode === 'print_web'"
						class="pa-block__row pa-block__row--block"
					>
						<contact-selector :showWarnings="showWarnings" />
					</div>

					<!-- <div class="pa-block__row pa-block__row--block">
						<label for="available-hours"
							><strong>Nombre d’heures / jours</strong></label
						>
						<div class="form-container">
							<input
								type="number"
								v-model="classified.hours_available"
								name="available_hours"
								id="available-hours"
							/>
						</div>
					</div>

					<div class="pa-block__row pa-block__row--block">
						<label for="salary"><strong>Salaire</strong></label>
						<div class="form-container">
							<input
								type="text"
								v-model="classified.salary"
								name="salary"
								id="salary"
							/>
						</div>
					</div>

					<div class="pa-block__row pa-block__row--block">
						<label for="price"><strong>Prix</strong></label>
						<div class="form-container">
							<input
								type="text"
								v-model="classified.user_price"
								name="price"
								id="price"
							/>
						</div>
					</div> -->

					<!-- <div class="pa-block__row pa-block__row--block multiselect">
            <label for="content"><strong>Mots clés</strong></label>
            <div class="form-container">
              <multiselect
                v-model="classified.tags"
                :options="[]"
                :taggable="true"
                :multiple="true"
                placeholder="Entré les mots clés"
                tag-placeholder="Entré les mots clés"
                @tag="addKeyword"
              >
              </multiselect>
            </div>
          </div> -->

					<div
						v-if="classified.profil == 'recruiter'"
						class="pa-block__row pa-block__row--block"
					>
						<label for="partner-url">
							<strong>URL du partenaire</strong>
						</label>
						<div class="form-container">
							<input
								type="url"
								v-model="classified.partner_url"
								name="partner_url"
								id="partner-url"
							/>
						</div>
					</div>

					<div class="pa-block__row pa-block__row--block">
						<logo-selector
							v-if="classified.uniq_id && classified.profil == 'recruiter'"
						/>
					</div>

					<div
						class="pa-block__row pa-block__row--block"
						v-if="classified.mode == 'web' || parseInt(classified.format)"
					>
						<medias-selector v-if="classified.uniq_id" />
					</div>
					<!-- .pa-block__row pa-block__row--block -->
				</div>
				<!-- pa-block__main -->
			</div>
			<!-- .pa-block__inner -->
		</div>
		<!-- .pa-block -->
	</div>
	<!-- .classified-resume -->
</template>
<script>
import axios from "axios";
import { mapState, mapGetters, mapMutations } from "vuex";
import { Editor, EditorContent } from "tiptap";
import { History } from "tiptap-extensions";
import OverQuota from "../plugins/EditorExtension";

import ProfessionSelector from "./ProfessionSelector.vue";
import RegionSelector from "./RegionSelector.vue";
import ContactSelector from "./ContactSelector.vue";
import ProfilEmail from "./ProfilEmail.vue";

import Multiselect from "vue-multiselect";
import LogoSelector from "./LogoSelector.vue";
import MediasSelector from "./MediasSelector.vue";

export default {
	name: "content-editor",
	components: {
		Multiselect,
		EditorContent,
		ProfessionSelector,
		RegionSelector,
		ContactSelector,
		LogoSelector,
		MediasSelector,
		ProfilEmail,
	},
	props: {
		showWarnings: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isLoadingCities: false,
			cities_options: [],
			titleFocused: false,
			contentFocused: false,
			contracts_group_idx: 0,
			xhrSource: null,
			editor: this.$browserDetect.isIE
				? null
				: new Editor({
						onUpdate: ({ getHTML }) => {
							this.contentFocused = true;
							this.setContent(getHTML());
						},
						extensions: [new History(), new OverQuota()],
				  }),
		};
	},
	mounted() {
		if (this.isIE) {
		} else {
			this.editor.setContent(this.classified.content);
		}
		this.$scrollTo("#main"); //, 300, { easing: "ease" });
		this.setMaxContentLength();
		this.setMaxMedias();
		// this.xhrSource = axios.CancelToken.source();
	},
	methods: {
		...mapMutations(["setContent", "setLogo", "setMedias"]),
		updateTitle(e) {
			this.$store.commit("setTitle", e.target.value);
		},
		updateContent(e) {
			// this.setContent();
		},
		addKeyword(newWord) {
			this.classified.tags.push(newWord);
		},
		handleSearchCities(value) {
			this.isLoadingCities = true;

			if (this.xhrSource) {
				this.xhrSource.cancel();
			}

			this.xhrSource = axios.CancelToken.source();
			this.searchCities(value);
		},
		searchCities(value) {
			axios
				.get(this.config.app.gateway, {
					cancelToken: this.xhrSource.token,
					params: {
						action: "search_cities_zipcode",
						s: value,
					},
					headers: {
						"Content-Type": "application/json",
					},
				})
				.then(({ data }) => {
					this.cities_options = data.cities ?? [];
					this.isLoadingCities = false;
				});
		},
	},
	computed: {
		...mapState(["classified", "settings", "maxLength", "getTownXhr"]),
		...mapGetters(["isAdmin", "getSettings", "getCurrentCategory"]),
		isIE() {
			return this.$browserDetect.isIE;
		},
		maxContent() {
			return this.maxLength;
		},
		maxTitle() {
			if (
				this.classified.mode == "print_web" &&
				this.classified.format == "simple"
			) {
				return 35;
			}

			if (this.classified.mode === "web") {
				return 100;
			}

			return 60;
		},
		remainingTitle() {
			return this.maxTitle - this.classified.title.length;
		},
		contentLength() {
			return this.classified.content.replace(/<[^>]*>/gim, "").length;
		},
		remainingContent() {
			return this.maxContent - this.contentLength;
		},
		cities: {
			get() {
				return this.classified.cities_data;
			},
			set(newCities) {
				const cities = newCities.slice(0, 10);

				this.classified.cities_data = cities;
				this.classified.cities = cities.map((c) => c.insee);
			},
		},
	},
	beforeDestroy() {
		if (!this.isIE) this.editor.destroy();
	},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.pa-block__row.multiselect {
	.form-container {
		padding: 0;
	}

	.multiselect__tags {
		border: 0;
	}

	.multiselect__tag {
		background-color: #d22e26;
		border-radius: 0;
		font-family: "Source Sans Pro";
		font-weight: 600;

		.multiselect__tag-icon::after {
			color: #fff;
		}

		.multiselect__tag-icon:hover {
			background-color: #fff;
			color: #d22e26;

			.multiselect__tag-icon::after {
				color: #d22e26;
			}
		}
	}
}

.ProseMirror {
	border: 1px solid grey;
	outline: none;
	overflow: auto;
}

.remaining {
	&.red {
		color: red;
	}
}

.pa-block__row {
	.content-editor & {
		padding-bottom: 1.7rem;
	}

	.form-container {
		border: 1px solid #d8d8d8;
	}

	.required,
	.maxLength {
		color: #d22e26;
	}

	.help {
		color: #9e9e9f;
		font-size: 0.9rem;
		margin-top: 5px;
	}

	.pa-checkbox__row {
		display: flex;
		flex-wrap: wrap;
		margin-top: 0.5rem;

		.pa-checkbox__item {
			flex: 0 0 50%;

			@media (max-width: 540px) {
				flex: 0 0 100%;
			}
		}

		label {
			display: flex;
			align-items: center;
			margin-top: 0.2rem;
		}
	}
}
</style>
